import React, { Component } from "react";
import CommonModalView from "presentational/common/modals/CommonModalView";
import TXT from "presentational/common/multinational/TXT";
import CommonTextField from "presentational/common/CommonTextField";
import config from "lib/fr-config";
import { withStyles } from "@material-ui/core/styles";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";
import Checkbox from "@material-ui/core/Checkbox";
import PropTypes from "prop-types";

const LAUNCH_CODE = "delete me";

const colorCss = config.css.color;

const CustomListItem = withStyles({
  root: { paddingLeft: 0, paddingRight: 0 }
})(ListItem);
const CustomCheckbox = withStyles({
  root: { marginLeft: -12 }
})(Checkbox);

class DeleteAccountModalView extends Component {
  static propTypes = {
    open: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
    onAccountDeletionConfirm: PropTypes.func.isRequired
  };

  state = {
    inputValue: "",
    checkbox1: false,
    checkbox2: false,
    checkbox3: false
  };

  initInputData() {
    this.setState({
      inputValue: "",
      checkbox1: false,
      checkbox2: false,
      checkbox3: false
    });
  }

  isCorrectActionEntered() {
    const { inputValue, checkbox1, checkbox2, checkbox3 } = this.state;
    return checkbox1 && checkbox2 && checkbox3 && inputValue === LAUNCH_CODE;
  }

  getModalContent() {
    const { inputValue, checkbox1, checkbox2, checkbox3 } = this.state;

    return (
      <div>
        <List>
          <CustomListItem>
            <CustomCheckbox
              checked={checkbox1}
              onChange={this.handleCheckboxChange}
              value={"checkbox1"}
              disableRipple
            />
            <ListItemText primary={<TXT name="msg_delAccountChkbox1st" />} />
          </CustomListItem>
          <CustomListItem>
            <CustomCheckbox
              checked={checkbox2}
              onChange={this.handleCheckboxChange}
              value={"checkbox2"}
              disableRipple
            />
            <ListItemText primary={<TXT name="msg_delAccountChkbox2nd" />} />
          </CustomListItem>
          <CustomListItem>
            <CustomCheckbox
              checked={checkbox3}
              onChange={this.handleCheckboxChange}
              value={"checkbox3"}
              disableRipple
            />
            <ListItemText primary={<TXT name="msg_delAccountChkbox3rd" />} />
          </CustomListItem>
        </List>
        <CommonTextField
          value={inputValue}
          onChange={this.handleInputChange}
          placeholder={LAUNCH_CODE}
          helperText={
            <span>
              <TXT
                name="msg_helperLaunchCodeInput"
                input={{ launchCode: LAUNCH_CODE }}
              />
            </span>
          }
        />
      </div>
    );
  }

  handleCheckboxChange = e => {
    const { value, checked } = e.target;
    this.setState({ [value]: checked });
  };

  handleInputChange = e => {
    this.setState({ inputValue: e.target.value });
  };

  handleCloseBtnClick = () => {
    this.initInputData();
    const { onClose } = this.props;
    onClose();
  };

  handleSubmitDeletionButton = () => {
    const { onAccountDeletionConfirm } = this.props;
    onAccountDeletionConfirm();
    this.initInputData();
  };

  render() {
    const { open } = this.props;

    return (
      <CommonModalView
        open={open}
        onClose={this.handleCloseBtnClick}
        titleText={<TXT name="titleModal_deleteAccount" />}
        contentComponent={this.getModalContent()}
        firstButtonText={<TXT name="btnModal_cancel" />}
        firstButtonFunc={this.handleCloseBtnClick}
        secondButtonText={<TXT name="btnModal_deleteAccount" />}
        secondButtonTextColor={
          this.isCorrectActionEntered() ? colorCss.colorOfDanger : undefined
        }
        secondButtonFunc={this.handleSubmitDeletionButton}
        secondButtonDisabled={!this.isCorrectActionEntered()}
      />
    );
  }
}

export default DeleteAccountModalView;
